import React from 'react';
import TabContent from './TabContent';

const AddressTab = ({
  data,
  reload,
  currentPage,
  itemsPerPage,
  selectedTab,
  onViewFile,
  onDeleteFile,
  selectedFileType,
}) => {
  // For Address tab, we want to show the latest file of the selected type
  // The data prop should already contain the latest file from the parent component
  const displayData = data || [];
  
  return (
    <TabContent
      data={displayData}
      reload={reload}
      currentPage={currentPage}
      itemsPerPage={itemsPerPage}
      selectedTab={selectedTab}
      onViewFile={onViewFile}
      onDeleteFile={onDeleteFile}
      selectedFileType={selectedFileType}
    />
  );
};

export default AddressTab;
